import _curry3 from "./internal/_curry3.js";
import defaultTo from "./defaultTo.js";
import path from "./path.js";
var pathOr = _curry3(function pathOr(d, p, obj) {
    return defaultTo(d, path(p, obj));
});
export default pathOr;
